import { useEffect, useState } from 'react';
import styles from './GamesStatTab.module.scss';

import DateNavigation from '../../../utils/DateNavigation/DateNavigation';
import MarkdownRenderer from '../../../utils/MarkdownRenderer/MarkdownRenderer';
import Flags from '../../../utils/Flags/Flags';

import { getFullGamesAchievedByPeriod } from '../../../utils/api/insightsAPI';

const GamesStatTab = () => {
	const [period, setPeriod] = useState('week');
	const [date, setDate] = useState(new Date());
	const [dateRange, setDateRange] = useState("");

	const [stats, setStats] = useState([]);
	const [openQuestions, setOpenQuestions] = useState({});
	const [loading, setLoading] = useState(false);

	useEffect(() => {
		const fetchStats = async () => {
		setLoading(true);
		try {
			const data = await getFullGamesAchievedByPeriod(period, date);
			setStats(data);
		} catch (error) {
			console.error('Erreur chargement stats jeux atypiques', error);
		}
		setLoading(false);
		};
		fetchStats();
	}, [period, date.getTime()]);

	const toggleQuestionsDetails = (infos) => {
		setOpenQuestions(prev => ({
		...prev,
		[infos.id]: !prev[infos.id]
		}));
	};
 
  	const formatTime = (seconds) => {
		if (typeof seconds !== 'number' || isNaN(seconds)) return 'N/A';
		const days = Math.floor(seconds / 86400);
		const hours = Math.floor((seconds % 86400) / 3600);
		const mins = Math.floor((seconds % 3600) / 60);
		const secs = Math.floor(seconds % 60);

		const parts = [];
		if (days > 0) parts.push(`${days}j`);
		if (hours > 0 || days > 0) parts.push(`${hours}h`);
		if (mins > 0 || hours > 0 || days > 0) parts.push(`${mins}m`);
		parts.push(`${secs < 10 && (mins > 0 || hours > 0 || days > 0) ? '0' : ''}${secs}s`);

		return parts.join(' ');
	};

  	return (
		<div className={styles.wrapper}>
			<div className={styles.header}>
				<h2 className={styles.title}>Formules insolites</h2>
				<p>({dateRange})</p>
			</div>

			<DateNavigation period={period} setPeriod={setPeriod} date={date} setDate={setDate} setDateRange={setDateRange} />

			{loading ? (
				<p>Chargement...</p>
			) : (
				<div className={styles.cardList}>
					{stats.map((jeu, i) => (
						<div className={styles.card} key={i}>
							<h3 className={styles.title}>{jeu.nom}</h3>
							<div className={styles.grid}>
								<div>
									<p className={styles.label}>Parties terminées</p>
									<p className={styles.datas}>{jeu.total_parties}</p>
								</div>
								<div>
									<p className={styles.label}>Joueurs estimés</p>
									<p className={styles.datas}>{jeu.total_players}</p>
								</div>
								<div>
									<p className={styles.label}>Variation</p>
									<p className={jeu.variation_parties >= 0 ? styles.variationUp : styles.variationDown}>
										{jeu.variation_parties >= 0 ? '+' : '-'}&nbsp;{Math.abs(jeu.variation_parties)}%
									</p>
								</div>
							</div>

							{jeu.total_parties > 0 && jeu.user_ids?.finished?.length > 0 && (
							<div className={styles.userList}>
								<p className={styles.label}>Joueurs ayant complété le jeu :</p>
								<ul>
								{jeu.user_ids.finished.map((user, idx) => (
									<li key={idx}>{user.email}</li>
								))}
								</ul>
							</div>
							)}

							<hr className={styles.hr} />

							{jeu.infos.map((parcours) => (
								<div key={parcours.id} className={styles.parcours}>
									<div className={styles.parcoursStats}>
										<p><Flags lang={parcours.lang} /> — Parties terminées : <strong>{parcours.nb_parties}</strong> | Joueurs : <strong>{parcours.nb_players}</strong></p>
										{parcours.nb_parties > 0 && (
											<button onClick={() => toggleQuestionsDetails(parcours)} className={styles.detailButton}>
												{openQuestions[parcours.id] ? 'Masquer' : 'Détails'}
											</button>
										)}
										
									</div>

									{openQuestions[parcours.id] && (
										<div className={styles.questionGrid}>
										{parcours.questions.map((q) => (
											<div key={q.id} className={styles.questionCard}>
												<div className={styles.questionLabel}><strong><MarkdownRenderer content={q.libelle.length > 45 ? q.libelle.slice(0, 45) + '…' : q.libelle} /></strong></div>
												{q.stats && (
													<ul className={styles.statsList}><em>Moyennes</em>
														<li>Temps : <strong>{formatTime(q.stats.avg_time)}</strong></li>
														<li>Boussoles : <strong>{q.stats.avg_compass ?? 'N/A'}</strong> /3</li>
														{/* <li>❌ Abandons : {q.stats.nb_abandons}</li> */}
													</ul>
												)}
											</div>
										))}
										</div>
									)}
								</div>
                            ))}

							{/* Carte "démarrées" */}
							{jeu.total_active_parties > 0 && (
							<div className={styles.subCard}>
								<div className={styles.subGrid}>
									<div>
										<p className={styles.label}>Parties démarrées</p>
										<p className={styles.datas}>{jeu.total_active_parties}</p>
									</div>
									{jeu.user_ids?.active?.length > 0 && (
									<div className={styles.emails}>
										<p className={styles.label}>Joueurs :</p>
										<p className={styles.email}>
										{jeu.user_ids.active.map(u => `${u.email}(${u.placement + 1})`).join(', ')}
										</p>
									</div>
									)}
									<div>
										<p className={styles.label}>Joueurs estimés</p>
										<p className={styles.datas}>{jeu.total_active_players}</p>
									</div>
								</div>
							</div>
							)}
						</div>
					))}
				</div>
			)}
		</div>
	);
};

export default GamesStatTab;
